// i18n.ts
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Importing translation JSON files
import translationCZ from './translations-cz.json';
import translationSK from './translations-sk.json';
import translationsHU from './translations-hu.json';

const resources = {
  cz: { translation: translationCZ },
  sk: { translation: translationSK },
  hu: { translation: translationsHU },
};

i18n.use(initReactI18next).init({
  resources,
  lng: window.country || process.env.REACT_APP_COUNTRY,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
